import React, { useState, useEffect } from "react";
import { Table, TableColumn } from "../../../components/table";
import TextBox from "../../../components/textfield/textbox";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory } from "react-router-dom";
import { Input } from "../../../components/textfield";
import Icon from "@mdi/react";
import { mdiFileUploadOutline } from "@mdi/js";
import "../../../assets/styles/admin/usedcourse.scss";
import { Upload, message, Button } from "antd";

const Courserenew1 = () => {
  const history = useHistory();
  const [renewCoures, setRenewCourses] = useState<any>([]);
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    console.log("e", e);
  }
  const columns = [
    {
      title: "No",
    },
    {
      title: "รายการ",
    },
    {
      title: "ทั้งหมด",
      align: "center",
    },
    {
      title: "ใช้ไปแล้ว",
      align: "center",
    },
    {
      title: "คงเหลือ",
      align: "center",
    },
    {
      title: "หมดอายุ",
      align: "center",
    },
    {
      title: "ต่ออายุ",
      align: "center",
    },
    {
      title: "ใบขอรับบริการ",
      align: "center",
    },
    {
      title: "ใบต่ออายุคอร์ส",
      align: "center",
    },
    {
      title: "สถานะคอร์ส",
      align: "center",
    },
  ];

  const data = [
    {
      _id: 1,
      code: "ADLC0802",
      list: "BBL (Gel) Face 10 free 3()",
      total: "13",
      used: "13",
      remaining: "0",
      unit: "Area",
      expiration_date: "18-12-2564",
    },
    {
      _id: 2,
      code: "ATFS0803",
      list: "Acne Clear",
      total: "5",
      used: "1",
      remaining: "4",
      unit: "ครั้ง",
      expiration_date: "18-10-2564",
    },
    {
      _id: 3,
      code: "ATFS0803",
      list: "Dual Yellow Face",
      total: "5,000.00",
      used: "1,000.00",
      remaining: "4,000.00",
      unit: "วงเงิน",
      expiration_date: "14-06-2564",
    },
  ];
  const data2 = [
    {
      _id: 1,
      list: "Dual Yellow 5 Times",
      total: "5,000.00",
      used: "1,000.00",
      remaining: "4,000.00",
      empire_date: "26-01-2564",
      renew_date: "26-07-2564",
      statuscourse: "Renewal",
      isUploaded: false,
    },
  ];

  const props = {
    name: "file",
    // action: "//jsonplaceholder.typicode.com/posts/",
    headers: {
      authorization: "authorization-text",
    },
  };

  const onUploadChange = (info: any, index: number) => {
    if (info?.file?.name) {
      console.log("upload here =>", info.file);
      // send file to upload

      // temp
      console.log("send index =>", index);

      let array = renewCoures;
      // array[index].isUploaded = true;
      array.forEach((value: any, ind: number) => {
        console.log("ind =>", ind);

        if (ind === index) {
          value.isUploaded = true;
          console.log("value change =>", value);
        }
      });

      console.log("array =>", array);

      setRenewCourses([
        {
          _id: 1,
          list: "Dual Yellow 5 Times",
          total: "5,000.00",
          used: "1,000.00",
          remaining: "4,000.00",
          empire_date: "26-01-2564",
          renew_date: "26-07-2564",
          statuscourse: "Renewal",
          isUploaded: true,
        },
      ]);

      console.log("set finished.");
    }
  };

  const getApi = async () => {
    setRenewCourses(data2);
  };

  useEffect(() => {
    console.log("renewCoures =>", renewCoures);
  }, [renewCoures]);

  useEffect(() => {
    getApi();
  }, []);

  return (
    <div>
      <HeaderBar title="ต่ออายุคอร์ส" btnBack />
      {/* <ConFirmModal type={1} show={showModal1} onClose={toggleModal1} /> */}
      <div style={{ padding: "20px 40px" }}>
        <div className="card-view" style={{ padding: "30px 10px" }}>
          <div className="row" style={{ padding: "0px 40px" }}>
            <TextBox
              className="col-3 text-box-usedc"
              title="Customer"
              value="Ms.A"
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="CN"
              value="Ek-CNF60100015"
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="SO"
              value="SO-63010147"
            />
            <Input
              className="col-3 input-usedc"
              title="DATE"
              type="date"
              value="2564-01-18"
            />
          </div>
          <div style={{ marginTop: "20px" }}>
            <Table header={columns}>
              {renewCoures.map((item: any, index: number) => (
                <tr
                  key={index}
                  // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                  style={{ cursor: "pointer" }}
                >
                  <TableColumn width="3%" align="center">
                    {index + 1}
                  </TableColumn>
                  <TableColumn width="20%">{item.list}</TableColumn>
                  <TableColumn width="5%" align="left">
                    {item.total}
                  </TableColumn>
                  <TableColumn width="5%" align="left">
                    {item.used}
                  </TableColumn>
                  <TableColumn width="5%" align="left">
                    {item.remaining}
                  </TableColumn>
                  <TableColumn width="10%" align="right">
                    {item.empire_date}
                  </TableColumn>
                  <TableColumn width="10%" align="right">
                    {item.renew_date}
                  </TableColumn>
                  <TableColumn width="5%" align="center">
                    <div className="radious-upload">
                      <Icon
                        path={mdiFileUploadOutline}
                        size="20"
                        color="#fff"
                      />
                      <input
                        type="file"
                        id="img-2"
                        name="img"
                        accept="image/*"
                        hidden
                        onChange={handleChange}
                      />
                    </div>
                  </TableColumn>
                  <TableColumn width="5%" align="center">
                    {item.isUploaded ? (
                      <>OK</>
                    ) : (
                      <Upload
                        {...props}
                        maxCount={1}
                        onChange={(info: any) => {
                          onUploadChange(info, index);
                        }}
                      >
                        <div className="radious-upload">
                          <Icon
                            path={mdiFileUploadOutline}
                            size="20"
                            color="#fff"
                          />
                        </div>
                      </Upload>
                    )}
                  </TableColumn>
                  <TableColumn width="10%" align="center">
                    {item.statuscourse}
                  </TableColumn>
                </tr>
              ))}
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Courserenew1;
